import { Button, Slider, Input, Checkbox, Tooltip, message } from 'antd';
import SvgIcon from '&/components/SvgIcon';
import { hddDownload, hddRenderSameAngle } from '&/utils/common';
import UpgradeModal from './UpgradeModal';
import ShareModal from './ShareModal';
import { editAlbum, createShare, editVirtualRoom } from '@/api/hdd/album';
import { useEffect } from 'react';
import { useRouterTarget } from '&/utils/customHooks';
import { resetRender } from '@/api/hdd/album';

import './index.scss';
export default function PhotoAlbumItem(props) {
    const {
        coverImageUrl: imgSrc,
        itemType = 'album',
        itemState = 'rendered',
        upgradeFn = () => {},
        deleteFn = () => {},
        checkedFn = () => {},
        // handleRerender = () => {},
    } = props;

    const typeMap = {
        album: 0,
        panorama: 1,
        panoramaVrRoom: 2,
    };

    const targetPage = useRouterTarget();

    const renderAtAngle = () => {
        console.log('渲染同角度');
        let params = { camera: props.camera, type: typeMap[itemType] };
        hddRenderSameAngle(params);
    };

    const previewBtnText = {
        album: '查看大图',
        panorama: '查看全景图',
        panoramaVrRoom: '浏览器查看',
    };

    const handleOpenBrowser = (renderId, editType) => {
        createShare({
            renderId,
            type: editType === 'panorama' ? 1 : 2,
        }).then(res => {
            if (!res.data) return;
            let url = `${window.location.host}/hdd/panoramaShare?shareCode=${
                res.data.shareCode
            }&panorama=${editType === 'panorama' ? 0 : 1}`;
            console.log('url', url);
            try {
                window.external.DispatchFun('Atlas', 'OpenBrowser', url);
            } catch (error) {
                Promise.reject(error);
                console.log(error);
            }
        });
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const upgradeHandle = () => {
        if (
            (props.resolution === '4k' && itemType === 'album') ||
            (props.resolution === '8k' && itemType === 'panorama')
        ) {
            return message.warning('该图片已是最高分辨率了');
        }
        setIsModalOpen(true);
        upgradeFn();
    };

    const [shareUrl, setShareUrl] = useState('');
    const [shareLoading, setShareLoading] = useState(false);
    const [expire, setExpire] = useState();
    const shareHandle = () => {
        setShareLoading(true);
        createShare({
            renderId: props.id,
            type: typeMap[itemType],
            title: title,
        }).then(res => {
            console.log(res);
            if (!res.data) return;
            setShareLoading(false);
            setShareUrl(
                res.data.domain +
                    `/pages/hdd/panoramaShare?shareCode=${
                        res.data.shareCode
                    }&panorama=${typeMap[itemType] - 1}`
            );
            let date = new Date(res.data.item.expireDate * 1000);

            setExpire(
                date.getFullYear() +
                    '年' +
                    (date.getMonth() + 1) +
                    '月' +
                    date.getDate() +
                    '日'
            );
        });
        setShareModalOpen(true);
    };

    const handleEditVrRoom = () => {
        targetPage({
            pathname: '/hdd/virtualHouseCerate',
            search: {
                id: props.id,
                schemeId: props.schemeId,
                type: 'edit',
            },
        });
    };

    const onDownload = url => {
        console.log('下载');
        // download(1, url);
        hddDownload([url]);
    };

    const renderBtnGroup = {
        album: [
            <Tooltip placement="top" title={'渲染同角度'}>
                <Button
                    type="text"
                    className="item"
                    key={0}
                    onClick={() => renderAtAngle()}>
                    <SvgIcon iconName="Icon-Camera" />
                </Button>
            </Tooltip>,
            <Tooltip placement="top" title={'下载'}>
                <Button
                    type="text"
                    key={1}
                    onClick={() =>
                        onDownload({
                            picturepath: props.renderUrl,
                            picturename: props.title,
                        })
                    }>
                    <SvgIcon iconName="Icon-Download1" />
                </Button>
            </Tooltip>,
            <Tooltip placement="top" title={'升级分辨率'}>
                <Button type="text" key={2} onClick={upgradeHandle}>
                    <SvgIcon iconName="Icon-Upgrade" />
                </Button>
            </Tooltip>,
            <Tooltip placement="top" title={'删除'}>
                <Button type="text" key={3} onClick={() => deleteFn(props.id)}>
                    <SvgIcon iconName="Icon-Trash" />
                </Button>
            </Tooltip>,
        ],
        panorama: [
            <Tooltip placement="top" title={'下载'}>
                <Button
                    type="text"
                    key={1}
                    onClick={() =>
                        onDownload({
                            picturepath: props.renderUrl,
                            picturename: props.title,
                        })
                    }>
                    <SvgIcon iconName="Icon-Download1" />
                </Button>
            </Tooltip>,
            <Tooltip placement="top" title={'升级分辨率'}>
                <Button type="text" key={2} onClick={upgradeHandle}>
                    <SvgIcon iconName="Icon-Upgrade" />
                </Button>
            </Tooltip>,
            <Tooltip placement="top" title={'分享'}>
                <Button
                    type="text"
                    className="item"
                    key={0}
                    onClick={shareHandle}>
                    <SvgIcon iconName="Icon-Share1" />
                </Button>
            </Tooltip>,
            <Tooltip placement="top" title={'删除'}>
                <Button type="text" key={3} onClick={() => deleteFn(props.id)}>
                    <SvgIcon iconName="Icon-Trash" />
                </Button>
            </Tooltip>,
        ],
        panoramaVrRoom: [
            <Tooltip placement="top" title={'分享'}>
                <Button type="text" className="item" key={0}>
                    <SvgIcon iconName="Icon-Share1" onClick={shareHandle} />
                </Button>
            </Tooltip>,
            <Tooltip placement="top" title={'增删全景图 '}>
                <Button
                    type="text"
                    className="item"
                    key={1}
                    onClick={handleEditVrRoom}>
                    <SvgIcon iconName="Icon-Edit" />
                </Button>
            </Tooltip>,
            <Tooltip placement="top" title={'删除'}>
                <Button type="text" key={2} onClick={() => deleteFn(props.id)}>
                    <SvgIcon iconName="Icon-Trash" />
                </Button>
            </Tooltip>,
        ],
    };

    const onViewDetail = () => {
        console.log('查看详情');
        if (itemType === 'album') {
            targetPage({
                pathname: '/hdd/photoAlbumDetail',
                search: { id: props.id, schemeId: props.schemeId },
            });
        } else if (itemType === 'panorama') {
            targetPage({
                pathname: '/hdd/panoramaDetail',
                search: { id: props.id, schemeId: props.schemeId },
            });
        } else {
            handleOpenBrowser(props.id, 'panoramaVrRoom');
        }
    };

    const onEditPanorama = () => {
        console.log('编辑全景图');
        if (itemType === 'panoramaVrRoom') {
            targetPage({
                pathname: '/hdd/panoramaEdit',
                search: {
                    id: props.id,
                    schemeId: props.schemeId,
                    type: 'panoramaVrRoom',
                },
            });
        } else {
            targetPage({
                pathname: '/hdd/panoramaEdit',
                search: {
                    id: props.id,
                    schemeId: props.schemeId,
                    type: 'panorama',
                },
            });
        }
    };

    const stateMap = itemState => {
        const MAP = {
            beforeQueue: {
                stateText: '排队中',
                stateTip: 'none',
                stateTimeLine: 'none',
                renderBtn: 'none',
                renderState: 'beforeRendering',
                btn: [
                    <Tooltip placement="top" title={'删除'} key={0}>
                        <Button
                            type="text"
                            key={0}
                            onClick={() => deleteFn(props.id)}>
                            <SvgIcon iconName="Icon-Trash" />
                            {/* <span className="outlined icon-Trash"></span> */}
                        </Button>
                    </Tooltip>,
                ],
            },
            inQueue: {
                stateText: '排队中',
                stateTip: `当前第${props.orderNum}位`,
                stateTimeLine: 'none',
                renderBtn: 'none',
                renderState: 'beforeRendering',
                btn: [
                    <Tooltip placement="top" title={'删除'} key={0}>
                        <Button
                            type="text"
                            key={0}
                            onClick={() => deleteFn(props.id)}>
                            <SvgIcon iconName="Icon-Trash" />
                        </Button>
                    </Tooltip>,
                ],
            },
            rendering: {
                stateText: '渲染中',
                stateTip: 'none',
                stateTimeLine: 'inprogress',
                renderBtn: 'none',
                renderState: 'rendering',
                btn: [
                    <Tooltip placement="top" title={'删除'} key={0}>
                        <Button
                            type="text"
                            key={0}
                            onClick={() => deleteFn(props.id)}>
                            <SvgIcon iconName="Icon-Trash" />
                        </Button>
                    </Tooltip>,
                ],
            },
            rendered: {
                stateText: 'none',
                stateTip: 'none',
                stateTimeLine: 'none',
                renderBtn: [
                    <Button key={0} className onClick={onViewDetail}>
                        {previewBtnText[itemType]}
                    </Button>,
                    itemType !== 'album' && (
                        <Button
                            className="edit-btn"
                            key={1}
                            onClick={onEditPanorama}>
                            编辑
                        </Button>
                    ),
                ],

                renderState: 'rendered',
                btn: renderBtnGroup[itemType],
            },
            failed: {
                stateText: '渲染失败',
                stateTip: 'none',
                stateTimeLine: 'none',
                renderBtn: (
                    <Button
                        className="reRender"
                        key={0}
                        onClick={handleRerender}>
                        重新渲染
                    </Button>
                ),
                renderState: 'renderFailed',
                btn: [
                    <Tooltip placement="top" title={'删除'} key={0}>
                        <Button
                            type="text"
                            key={0}
                            onClick={() => deleteFn(props.id)}>
                            <SvgIcon iconName="Icon-Trash" />
                        </Button>
                    </Tooltip>,
                ],
            },
            upgradeFailed: {
                stateText: '渲染失败',
                stateTip: 'none',
                stateTimeLine: 'none',
                renderBtn: (
                    <Button className="reRender" key={0}>
                        重新渲染
                    </Button>
                ),
                renderState: 'upgradeFailed',
                btn: [
                    <Tooltip placement="top" title={'删除'} key={0}>
                        <Button
                            type="text"
                            key={0}
                            onClick={() => deleteFn(props.id)}>
                            <SvgIcon iconName="Icon-Trash" />
                        </Button>
                    </Tooltip>,
                ],
            },
        };
        return MAP[itemState];
    };

    const inputRef = useRef(null);
    const [title, setTitle] = useState('');

    useEffect(() => {
        console.log(inputRef.current);
        setTitle(props.title);
    }, [props.title]);

    const defaultTitle = useRef(props.title);

    const editTitle = title => {
        if (title === '') {
            message.warning('效果图名称不能为空');
            setTitle(defaultTitle.current);
            return;
        }
        if (title === defaultTitle.current) return;
        let apiName;
        if (itemType === 'panoramaVrRoom') {
            apiName = editVirtualRoom;
        } else {
            apiName = editAlbum;
        }
        apiName({ renderId: props.id, title: title }).then(() => {
            defaultTitle.current = title;
        });
    };

    const sharedProps = {
        style: {
            width: '100%',
        },
        defaultValue: '',
        ref: inputRef,
        value: title,
        onChange: e => {
            setTitle(e.target.value);
        },
        onBlur: e => {
            editTitle(e.target.value);
        },
        onPressEnter: e => {
            editTitle(e.target.value);
        },
    };

    const onChange = e => {
        console.log(`checked = ${e.target.checked}`);
        checkedFn(e.target.checked);
    };

    const [shareModalOpen, setShareModalOpen] = useState(false);

    const handleRerender = () => {
        resetRender({ renderId: props.id }).then(res => {
            message.success('重新渲染成功');
            props.getCurList();
        });
    };

    const getSecond = rate => {
        let second = 60 - parseInt((rate / 100) * 60);
        if (second < 10) {
            return '0' + second.toString();
        }
        return second;
    };

    return (
        <div className="photo-album-item">
            <div className={`img-box ${props.checked ? 'img-box-hover' : ''}`}>
                <img
                    className="room-img"
                    src={
                        !imgSrc
                            ? require('@/assets/img/album-default.png').default
                            : imgSrc
                    }
                    alt=""
                />
                <div className="resolution-tip-rendered">
                    {props.resolution}
                </div>

                <div
                    className={`img-mask ${
                        stateMap(itemState)['renderState'] === 'rendered'
                            ? 'img-hover-mask'
                            : ''
                    }`}>
                    <div className="resolution-tip">{props.resolution}</div>
                    {stateMap(itemState)['renderState'] === 'rendered' && (
                        <Checkbox
                            onChange={onChange}
                            checked={props.checked}
                            className="checkbox"></Checkbox>
                    )}
                    {stateMap(itemState)['stateText'] !== 'none' && (
                        <div className="img-mask-stateText">
                            {stateMap(itemState)['stateText']}
                        </div>
                    )}
                    {stateMap(itemState)['renderBtn'] !== 'none' && (
                        <div className="img-mask-renderBtn">
                            {stateMap(itemState)['renderBtn']}
                        </div>
                    )}

                    {stateMap(itemState)['stateTimeLine'] !== 'none' && (
                        <div className="img-mask-slider">
                            <div className="slider-tip">
                                <div className="rest-time">
                                    00:{getSecond(props.rate)}
                                </div>
                                <div className="percentage">{props.rate}%</div>
                            </div>
                            <Slider
                                defaultValue={props.rate}
                                value={props.rate}
                                tooltip={{
                                    visible: false,
                                }}
                            />
                        </div>
                    )}

                    {stateMap(itemState)['stateTip'] !== 'none' && (
                        <div className="img-mask-stateTip">
                            {stateMap(itemState)['stateTip']}
                        </div>
                    )}
                </div>
            </div>
            <div className="img-info">
                <div className="img-size">
                    {' '}
                    <Input
                        {...sharedProps}
                        onClick={() => {
                            console.log(111231);
                            inputRef.current.focus({
                                cursor: 'all',
                            });
                        }}
                    />{' '}
                </div>
                <div className="img-operate-btn-wrap">
                    {stateMap(itemState)['btn'].map((item, index) => (
                        <span key={index}>{item}</span>
                    ))}
                </div>
            </div>
            {itemType !== 'panoramaVrRoom' && (
                <UpgradeModal
                    isModalOpen={isModalOpen}
                    itemType={itemType}
                    getCurList={props.getCurList}
                    {...props}
                    setIsModalOpen={setIsModalOpen}
                />
            )}
            {itemType !== 'album' && (
                <ShareModal
                    isModalOpen={shareModalOpen}
                    setIsModalOpen={setShareModalOpen}
                    loading={shareLoading}
                    copyUrl={shareUrl}
                    expire={expire}
                    curResolution={props.resolution}
                    pixelAspect={props.pixelAspect}
                />
            )}
        </div>
    );
}
